/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * Application version + which box is serving it.
 *
 * The version is injected at build time from the repo-root version.json
 * (see vite.config.ts and scripts/bump-build.mjs).
 *
 * The ENVIRONMENT is deliberately resolved at RUNTIME from the hostname, not
 * baked in at build time: a release ships the *same* JAR to UAT and production,
 * so a compile-time constant would make UAT proudly announce "PROD".
 */

export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0000';

export const BUILD_TIME: string =
  typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : '';

export type AppEnvironment = 'PROD' | 'UAT' | 'DEV' | 'UNKNOWN';

/** Resolve the environment from the hostname/port the app is served from. */
export function getEnvironment(host?: string, port?: string): AppEnvironment {
  const hostname = (host ?? window.location.hostname).toLowerCase();
  const p = port ?? window.location.port;

  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]') {
    return 'DEV';
  }
  if (hostname === 'the-corex-suite.com' || hostname.endsWith('.the-corex-suite.com')) {
    return 'PROD';
  }
  // UAT is the only box reached over a raw EC2 hostname / on port 9090.
  if (p === '9090' || hostname.includes('amazonaws.com')) {
    return 'UAT';
  }
  return 'UNKNOWN';
}

/** e.g. "PROD · V0.1.0001" — or just "V0.1.0001" when the box is unrecognised. */
export function getVersionLabel(env: AppEnvironment = getEnvironment()): string {
  const version = `V${APP_VERSION}`;
  return env === 'UNKNOWN' ? version : `${env} · ${version}`;
}
